import * as React from 'react'
import Box from '@mui/material/Box'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { Typography } from '@mui/material'
import SelectField from '../../../components/Common/SelectBox'
import TextField from 'components/Common/TextField'
import { useSelector, useDispatch } from 'react-redux'
import { updateSearchCriteria, fetchFetchCompany } from 'store/actions/businessListingActions'
import './index.css'
import Button from 'components/Common/Button'
import { PRIMARY_BUTTON, DISABLED_BUTTON, SECONDARY_BUTTON } from 'themes/theme'
import filterIcon from 'assets/icons/Filter_Icon.svg'
import CloseIcon from '@mui/icons-material/Close'

const FilterBox = () => {
  const businessReducer = useSelector(state => state.businessReducer)
  const { searchCriteria } = businessReducer
  const { zipCode, miles, establishedYearRange } = searchCriteria
  const disableAction = zipCode || miles || establishedYearRange.from || establishedYearRange.to ? true : false
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [formTouch, setformTouch] = React.useState(false)
  const open = Boolean(anchorEl)
  const distances = [0, 5, 10, 25, 50, 100, 500]
  const distanceOptions = distances.map(value => {
    const label = value === 0 ? 'Any' : value
    return { label, value }
  })

  const fromYear = 1970
  const nowYear = new Date().getFullYear()
  const yearOptions = [{ value: 0, label: 'Any' }]
  for (let i = fromYear; i <= nowYear; i += 1) {
    const option = { value: i, label: String(i) }
    yearOptions.push(option)
  }

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleChange = event => {
    setformTouch(true)
    const { name, value } = event.target
    let updatedSearch
    if (name === 'fromYear') {
      updatedSearch = {
        ...searchCriteria,
        establishedYearRange: {
          ...searchCriteria.establishedYearRange,
          from: value,
        },
      }
    } else if (name === 'toYear') {
      updatedSearch = {
        ...searchCriteria,
        establishedYearRange: {
          ...searchCriteria.establishedYearRange,
          to: value,
        },
      }
    } else {
      updatedSearch = {
        ...searchCriteria,
        [name]: value,
      }
    }
    updateSearchCriteria(dispatch, updatedSearch)
  }

  const clearSearch = () => {
    setformTouch(false)
    const updatedSearchFields = {
      ...searchCriteria,
      zipCode: '',
      miles: 0,
      establishedYearRange: {
        from: 0,
        to: 0,
      },
      skip: 0,
    }
    updateSearchCriteria(dispatch, updatedSearchFields)
  }
  const handleSearch = e => {
    e.preventDefault()
    setformTouch(false)
    setAnchorEl(false)
    const updatedSearchCriteria = { ...searchCriteria, skip: 0 }
    updateSearchCriteria(dispatch, updatedSearchCriteria)
    fetchFetchCompany(dispatch, updatedSearchCriteria)
  }

  return (
    <>
      <img style={{ cursor: 'pointer' }} onClick={handleClick} src={filterIcon} alt="filterIcon" />
      <Menu
        id="filterSelection"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box component="form" className="p-4" minWidth="400px" onSubmit={handleSearch}>
          <CloseIcon
            onClick={handleClose}
            fontSize="large"
            sx={{
              cursor: 'pointer',
              position: 'absolute',
              top: '10px',
              right: '10px',
              color: '#9292Af',
            }}
          />
          <Box className="py-3">
            <Typography variant="h6">Distance</Typography>
            <div className={'selectsWrapper'}>
              <div className={'paddingSmall'}>
                <Box display="flex" alignItems="center" marginTop="10px">
                  <Typography component="span" variant="body2" marginRight="10px">
                    within
                  </Typography>
                  <SelectField onChange={handleChange} name="miles" value={searchCriteria.miles}>
                    {distanceOptions.map(item => (
                      <MenuItem
                        className={'option'}
                        key={item.value}
                        value={item.value}
                        sx={{ borderRadius: '5px', color: '#66668f' }}
                      >
                        <span className={'option'}>{item.label}</span>
                      </MenuItem>
                    ))}
                  </SelectField>
                </Box>
              </div>
              <Box display="flex" alignItems="center" marginTop="10px">
                <Typography component="span" variant="body2" margin="0px 10px">
                  miles of zip code
                </Typography>
                <TextField
                  onChange={handleChange}
                  variant="outlined"
                  bgwhite
                  name="zipCode"
                  value={searchCriteria.zipCode}
                  className="mt-0 bootstrapLabel"
                  error={searchCriteria.miles && !searchCriteria.zipCode}
                  sx={{ height: 50, width: 100 }}
                />
              </Box>
            </div>
            <Box textAlign="right" visibility={searchCriteria.miles && !searchCriteria.zipCode ? 'visible' : 'hidden'}>
              <Typography color="error" variant="subtitle1">
                Please Enter ZIP code
              </Typography>
            </Box>
          </Box>
          <Box className="py-3">
            <Typography variant="h6">Established</Typography>
            <div className={'selectsWrapper'}>
              <div className={'paddingSmall'}>
                <Box display="flex" alignItems="center">
                  <Typography component="span" variant="body2" marginRight="10px">
                    from year
                  </Typography>
                  <SelectField onChange={handleChange} name="fromYear" value={searchCriteria.establishedYearRange.from}>
                    {yearOptions.map(item => (
                      <MenuItem key={item.value} value={item.value} sx={{ borderRadius: '5px', color: '#66668f' }}>
                        <span className={'option'}>{item.label}</span>
                      </MenuItem>
                    ))}
                  </SelectField>
                </Box>
              </div>
              <div className={'paddingSmall'}>
                <Box display="flex" alignItems="center">
                  <Typography component="span" variant="body2" marginRight="10px">
                    to year
                  </Typography>
                  <SelectField onChange={handleChange} name="toYear" value={searchCriteria.establishedYearRange.to}>
                    {yearOptions.map(item => (
                      <MenuItem key={item.value} value={item.value} sx={{ borderRadius: '5px', color: '#66668f' }}>
                        <span className={'option'}>{item.label}</span>
                      </MenuItem>
                    ))}
                  </SelectField>
                </Box>
              </div>
            </div>
          </Box>
          <Box display="flex" justifyContent="end" gap="10px" className="mt-4">
            <Button
              type={disableAction ? SECONDARY_BUTTON : DISABLED_BUTTON}
              disabled={!disableAction}
              onClick={clearSearch}
              fullWidth
            >
              Clear All
            </Button>
            <Button
              submit
              onClick={handleSearch}
              type={
                formTouch || disableAction || (!searchCriteria.miles && searchCriteria.zipCode)
                  ? PRIMARY_BUTTON
                  : DISABLED_BUTTON
              }
              disabled={!formTouch || !disableAction || (searchCriteria.miles && !searchCriteria.zipCode)}
              fullWidth
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>
    </>
  )
}

export default FilterBox
